export function usePagination() {
  function getSlicedArray(array, itemsPerPage, currentPage) {
    return array.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  }

  return {
    getSlicedArray,
  };
}
